import { formValueSelector, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';

import { required } from '@utils/validators';
import { FC } from 'react';
import { Availability } from './Availability';

const validate = (values) => {
  const errors: { visitDate?: string; arrivalTime?: string } = {};

  errors.visitDate = required(values.visitDate);
  errors.arrivalTime = required(values.arrivalTime);

  return errors;
};

const selector = formValueSelector('spaEntityConfigurationForm');

const mapStateToProps = (state) => ({
  property: entitySelectors.getProperty(state),
  startDate: selector(state, 'startDate'),
  visitDate: selector(state, 'visitDate'),
  selectedArrivalTime: selector(state, 'arrivalTime'),
  reservedSpaTimeSlots: basketSelectors.getReservedSpaTimeSlots(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeJourneyParam,
    },
    dispatch
  );

const AvailabilityReduxForm = reduxForm({
  form: 'spaEntityConfigurationForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(Availability as FC);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AvailabilityConnected: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(AvailabilityReduxForm);
